









import { Component, Vue } from 'vue-property-decorator';
import { DxColumn } from 'devextreme-vue/data-grid';
import EntityListPage from '@/views/shared/EntityListPage.vue';

@Component({
  components: {
    EntityListPage,
    DxColumn
  }
})
export default class ListiniTariffePage extends Vue {
  constructor() {
    super();
  }
}
